import { render } from "./ExpertiseStage.vue?vue&type=template&id=2ffc3a2a&scoped=true"
import script from "./ExpertiseStage.vue?vue&type=script&lang=js"
export * from "./ExpertiseStage.vue?vue&type=script&lang=js"

import "./ExpertiseStage.vue?vue&type=style&index=0&id=2ffc3a2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffc3a2a"]])

export default __exports__